import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ChartComponent} from "./chart.component";
import {HighchartsChartModule} from "highcharts-angular";
import {ChartService} from "./chart-service";
import {
  DxBoxModule, DxButtonModule, DxListModule, DxPopupModule, DxRadioGroupModule, DxResponsiveBoxModule, DxTabPanelModule,
  DxTreeListModule, DxTabsModule, DxLoadPanelModule
} from "devextreme-angular";
import {DxoPagerModule} from "devextreme-angular/ui/nested/pager";
import {DxoPagingModule} from "devextreme-angular/ui/nested/paging";
import {DeviceDetectorModule} from "ngx-device-detector";
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ChartComponent,
  }
];
@NgModule({
  imports: [
    CommonModule,
    DxTabPanelModule,
    DxBoxModule,
    DxPopupModule,
    DxTreeListModule,
    DxListModule,
    DxButtonModule,
    DxResponsiveBoxModule,
    HighchartsChartModule,
    DxRadioGroupModule,
    DeviceDetectorModule.forRoot(),
    DxoPagingModule,
    DxoPagerModule,
    DxTabsModule,
    DxLoadPanelModule
  ],
  declarations: [ChartComponent],
  providers: [ChartService],
  exports: [ChartComponent]
})
export class ChartModule { }



// WEBPACK FOOTER //
// ./src/app/components/chart/chart.module.ts